module.exports = __webpack_public_path__ + "static/img/sb.c17622f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/sb.png
// module id = Y07d
// module chunks = 18